import React from 'react';

// Map tickers to ISO Country Codes for FlagCDN
// Special case: 'BTC' will use the Emoji because it works everywhere
const ISO_MAP = {
  '^N225': 'jp',      // Japan
  '^HSI': 'hk',       // Hong Kong
  '^AXJO': 'au',      // Australia
  '000001.SS': 'cn',  // China
  '^FTSE': 'gb',      // UK
  '^GDAXI': 'de',     // Germany
  '^FCHI': 'fr',      // France
  '^STOXX50E': 'eu',  // Europe
  '^GSPC': 'us',      // USA
  '^DJI': 'us',       // USA
  '^IXIC': 'us',      // USA
  '^BVSP': 'br',      // Brazil
  '^KS11': 'kr',      // South Korea
  '^TWII': 'tw',      // Taiwan
  '^JKSE': 'id',      // Indonesia
  '^STI': 'sg',       // Singapore
  '^KLSE': 'my',      // Malaysia
  'BTC-USD': 'BITCOIN' // Special handling
};

export const IndexCard = ({ item, theme, name }) => {
  const code = ISO_MAP[item.symbol];
  const isPos = (item.changePercent || 0) >= 0;

  // Render Logic: Image for countries, Emoji for Bitcoin/Fallback
  const renderWatermark = () => {
    if (code === 'BITCOIN') {
      return (
        <span style={{ fontSize: '6rem', filter: 'grayscale(1)' }}>
          ₿
        </span>
      );
    }
    if (code) {
      return (
        <img 
          src={`https://flagcdn.com/w320/${code}.png`}
          alt="flag"
          style={{
            width: '140px',
            height: 'auto',
            transform: 'rotate(-15deg)', // Tilt it for style
            filter: 'grayscale(0.6)',    // Make it look classy/faded
            display: 'block'
          }}
        />
      );
    }
    // Fallback if unknown
    return <span style={{ fontSize: '6rem' }}>🌐</span>;
  };

  return (
    <div style={{
      minWidth: '260px',
      background: `linear-gradient(135deg, ${theme.cardBg}, rgba(255,255,255,0.02))`,
      padding: '1.5rem',
      borderRadius: '20px',
      border: `1px solid ${theme.border}`,
      position: 'relative',
      overflow: 'hidden',
      transition: 'transform 0.2s, box-shadow 0.2s',
      cursor: 'default',
      backdropFilter: 'blur(10px)',
      boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = 'translateY(-5px)';
      e.currentTarget.style.boxShadow = '0 12px 30px rgba(0,0,0,0.2)';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = 'translateY(0)';
      e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.1)';
    }}
    >
      {/* Content Layer (z-index 2) */}
      <div style={{ position: 'relative', zIndex: 2 }}>
        
        {/* The "Tag" */}
        <div style={{ 
          display: 'inline-flex', 
          alignItems: 'center',
          gap: '6px',
          padding: '4px 10px', 
          borderRadius: '6px', 
          background: isPos ? 'rgba(74, 222, 128, 0.1)' : 'rgba(239, 68, 68, 0.1)', 
          color: isPos ? '#4ade80' : '#ef4444', 
          fontSize: '0.7rem', 
          fontWeight: 'bold',
          marginBottom: '1rem',
          border: `1px solid ${isPos ? 'rgba(74, 222, 128, 0.2)' : 'rgba(239, 68, 68, 0.2)'}`
        }}>
          <span>{item.symbol.replace('^', '')}</span>
          <span>•</span>
          <span>{isPos ? 'BULL' : 'BEAR'}</span>
        </div>

        {/* Index Name */}
        <div style={{ 
          fontSize: '0.9rem', 
          color: theme.textSecondary, 
          fontWeight: '600', 
          marginBottom: '0.2rem',
          textTransform: 'uppercase',
          letterSpacing: '0.5px'
        }}>
          {name}
        </div>

        {/* Price */}
        <div style={{ 
          fontSize: '1.8rem', 
          fontWeight: '800', 
          fontFamily: 'monospace',
          color: theme.textPrimary,
          marginBottom: '0.5rem',
          letterSpacing: '-1px'
        }}>
          {item.price?.toLocaleString(undefined, {minimumFractionDigits: 2}) || "0.00"}
        </div>

        {/* Change stats */}
        <div style={{ 
          fontSize: '0.95rem', 
          color: isPos ? '#4ade80' : '#ef4444',
          fontWeight: '700',
          display: 'flex', alignItems: 'center', gap: '0.5rem'
        }}>
          {isPos ? '▲' : '▼'} {Math.abs(item.changePercent || 0).toFixed(2)}%
        </div>
      </div>

      {/* The Watermark Layer (z-index 1) */}
      <div style={{ 
        position: 'absolute', 
        right: '-30px', 
        bottom: '-30px', 
        opacity: 0.15, 
        pointerEvents: 'none',
        userSelect: 'none',
        zIndex: 1
      }}>
        {renderWatermark()}
      </div>
    </div>
  );
};